module.exports = __webpack_public_path__ + "static/img/RASR3_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASR3_1.png
// module id = fqsJ
// module chunks = 0